import { restApi } from './restApiSlice';

const queryParamsToConvertToNumber = [
  'responseTimeLow',
  'responseTimeHigh',
  'renderedTimeLow',
  'renderedTimeHigh',
  'statusCodeEq',
  'statusCodeLow',
  'statusCodeHigh',
];

export const rendersApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    exportHistory: builder.mutation({
      query: (inputParams) => ({
        url: '/v3/renders/history/export',
        method: 'POST',
        params: Object.fromEntries(
          Object.entries(inputParams)
            .filter(([_paramName, param]) => param != null && param !== '')
            .map(([paramName, param]) => [
              paramName,
              queryParamsToConvertToNumber.includes(paramName) ? Number(param) : param,
            ])
        ),
      }),
    }),
    recacheStats: builder.query({
      query: (params) => ({
        url: '/v3/renders/recache-stats',
        method: 'GET',
        params: Object.fromEntries(
          Object.entries(params)
            .filter(([key, value]) => value != null && value !== '')
            .map(([key, value]) => [key, queryParamsToConvertToNumber.includes(key) ? Number(value) : value])
        ),
      }),
      providesTags: ['recacheStats'],
    }),
  }),
});

export const { useExportHistoryMutation, useRecacheStatsQuery } = rendersApiSlice;
